import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { LoopPlannerSandboxApi } from '@/lib/api/loop-planner/sandbox';
import { loopPlannerQueryKeys } from '@/lib/query-keys/loop-planner';

export const getSandboxQueryOptions = ({ loopId }: { loopId: number }) =>
  queryOptions({
    queryKey: loopPlannerQueryKeys.sandbox.current({ loopId }),
    queryFn: () => LoopPlannerSandboxApi.getSandbox({ loopId }),
    refetchOnWindowFocus: true,
    staleTime: 0,
  });

export const useGetSandbox = ({ loopId }: { loopId: number }) => {
  return useQuery(getSandboxQueryOptions({ loopId }));
};

export const useGetSandboxSuspense = ({ loopId }: { loopId: number }) => {
  return useSuspenseQuery(getSandboxQueryOptions({ loopId }));
};
